interface IBuildActionProps {
  action: any;
  pending?: (state: any, action?: any) => void;
  fulfilled?: (state: any, action?: any) => void;
  rejected?: (state: any, action?: any) => void;
}

const buildAction = (builder, props: IBuildActionProps) => {
  if (!props) {
    console.log("No props provided to buildAction - something is wrong");
    return;
  }

  const { action, pending, fulfilled, rejected } = props;

  if (pending) {
    builder.addCase(action.pending, pending);
  }
  if (fulfilled) {
    builder.addCase(action.fulfilled, fulfilled);
  }
  if (rejected) {
    builder.addCase(action.rejected, rejected);
  }
};

export default buildAction;
